module.exports = __webpack_public_path__ + "static/img/datikuang.6eca4b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/datikuang.png
// module id = rI+p
// module chunks = 0